'use strict';

import React from 'react';
import axios from 'axios';
import { ResearchAreaSelection } from './Form.jsx';

export default class ResearchAreas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            researchAreas: [],
            loadFailed: false
        };
        this.handleRefresh = this.handleRefresh.bind(this);
    }

    handleRefresh(e) {
        e.preventDefault();
        window.location.reload();
    }

    componentDidMount() {
        axios.get(this.props.source)
            .then(res => {
                this.setState({
                    researchAreas: res.data
                });
            })
            .catch(() => {
                this.setState({
                    loadFailed: true
                });
            });
    }

    componentDidUpdate(prevProps, prevState) {
        prevState.researchAreas.length === 0 && this.state.researchAreas.length > 0 ? window.dk.bindAccordions() : null;
    }


    render() {
        const getId = () => `tpn-${Math.floor(Math.random() * 100000).toString(26)}`;
        let status;

        if (this.state.researchAreas.length === 0) {
            status = this.state.loadFailed ?
                <div className="thin-box sans-serif strong text-dark accent-orange">
                    We were unable to load the list of Research Area selections. <a href="#" onClick={this.handleRefresh}>Click here</a> to
                    reload the form and try again.
                </div> :
                <div className="thin-box sans-serif strong text-dark">
                    Please wait while we load the Research Area selections...
                </div>;
        }

        return (
            <ResearchAreaSelection.Consumer>
                {context => (
                    <div>
                        <h3>Select Research Areas<span className="red-required">*</span></h3>
                        <p>
                            Identify your research areas of expertise (imaging, -omics, cell biology, etc. are included within each disease category).
                            Please click on at least one scientific focus area below and select all that apply. If none of the scientific focus areas
                            are related to your research, please provide a description of your research below.
                        </p>
                        {
                            (this.state.researchAreas.length === 0 || this.state.loadFailed) ?
                            status :
                            <div className="dk-accdn accent-green field options" data-no-anchors>
                                <div className="acc-main">
                                    {this.state.researchAreas.map((selection, key) => {
                                        let tab = getId(), panel = getId();
                                        return <React.Fragment key={key}>
                                            <h4 className="acc-title"><button type="button" id={tab} aria-controls={panel} aria-expanded="false">{selection.category}</button></h4>
                                            <div className="acc-content" id={panel} aria-labelledby={tab}>
                                                <span className="group">
                                                    <div className="research-area-container">
                                                        {selection.areas.map((area, key) => {
                                                            const fieldId = Math.floor(Math.random() * Math.floor(10000));
                                                            return <div className="field research-area" key={key}>
                                                                <input
                                                                    type="checkbox"
                                                                    id={fieldId}
                                                                    value={area}
                                                                    checked={context.state.selectedAreas.indexOf(area) >= 0}
                                                                    onChange={context.handleAreaCheck}
                                                                    name="research-area" />
                                                                <label htmlFor={fieldId}>{area}</label>
                                                            </div>;
                                                        })}
                                                    </div>
                                                </span>
                                            </div>
                                        </React.Fragment>;
                                    })}
                                </div>
                            </div>
                        }
                    </div>
                )}
            </ResearchAreaSelection.Consumer>
        );
    }
}
